<template>
  <main id="tutorial-main">
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('tutorials.title') }}
        </el-col>
      </el-row>

      <el-row class="bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col class="default-section-title">
              {{ this.title }}
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col class="text-align-center">
              <div class="embedded-video-container">
                <iframe :title="title" class="embedded-video-frame" :src="src" allowfullscreen></iframe>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import constants from '@/utils/constants';

export default {
  name: 'Tutorial',
  computed: {
    title() {
      const tutorial = constants.TUTORIALS.ALL.find(t => t.name === this.$route.name);
      if (tutorial) {
        return this.$t(tutorial.title);
      }
      return this.$t(constants.TUTORIALS.DEFAULT.title);
    },
    src() {
      const tutorial = constants.TUTORIALS.ALL.find(t => t.name === this.$route.name);
      if (tutorial) {
        return tutorial.url;
      }
      return constants.TUTORIALS.DEFAULT.url;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .embedded-video-container {
    margin: auto;
    position: relative;
    overflow: hidden;
    padding-top: 56.25%;
    max-width: 960px;
    max-height: 480px;
  }
  .embedded-video-frame {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
    max-width: 960px;
    max-height: 480px;
  }
</style>
